// extracted by mini-css-extract-plugin
export var closeButton = "_go-1";
export var closeX = "_go-3";
export var container = "_go-0";
export var image = "_go-2";